module.exports = __webpack_public_path__ + "img/interface_prize_bg.2f578b01.png";